<template>
  <footer id="footer">
    <div class="top">
      <div class="inner">
        <ul class="link">
          <li>
            <button
              title="개인정보처리방침"
              @click="
                openWebsite(
                  'https://www.insiseol.or.kr/main/guidance/policy/privacy_policy.jsp',
                )
              "
            >
              <b>개인정보처리방침</b>
            </button>
          </li>
          <li>
            <button title="이메일수집거부" @click="openEmailModal">
              이메일수집거부
            </button>
          </li>
        </ul>
        <!-- <div class="family-site">
          <label for="familySite" class="hidden">인천시 패밀리 사이트</label>
          <select
            title="패밀리사이트 선택"
            id="familySite"
            @change="goExternalSite"
            @keydown.up="eventStem($event)"
            @keydown.right="eventStem($event)"
            @keydown.down="eventStem($event)"
            @keydown.left="eventStem($event)"
            ref="moveSite"
          >
            <option value="/main" selected>패밀리사이트</option>
            <option value="https://www.insiseol.or.kr/main/">
              인천시설공단
            </option>
            <option value="https://www.incheon.go.kr/index">인천시청</option>
            <option value="https://www.ih.co.kr/open_content/main/">
              인천도시공사
            </option>
            <option value="https://www.eco-i.or.kr/main/main.asp">
              인천환경공단
            </option>
            <option value="https://www.ictr.or.kr/main/">인천교통공사</option>
            <option value="https://www.icmc.or.kr/">인천의료원</option>
            <option value="http://www.icren.kr/home">
              인천시정연구네트워크
            </option>
          </select>
        </div> -->
      </div>
    </div>
    <div class="bottom">
      <div class="inner sb">
        <div class="flex">
          <img
            :src="require('@/assets/images/common/footer-logo.svg')"
            alt="인천시설공단 로고"
            @click="openWebsite('https://www.insiseol.or.kr/')"
          />
          <address class="footer-address">
            <p class="address">
              [22717] 인천 서해구 봉수대로 806 상가주차사업단 주차팀
              <br class="mobile" />
              TEL:032-579-2701~3
            </p>
            <p class="copyright">
              Copyright ⓒ Incheon Metropolitan City. All rights reserved.
            </p>
          </address>
        </div>
        <div>
          <img
            :src="require('@/assets/images/common/logo_incheonsi.svg')"
            alt="인천광역시 로고"
            @click="openWebsite('https://www.incheon.go.kr/index')"
          />
        </div>
      </div>
    </div>

    <email-modal v-if="showEmailModal">
      <template #info> 이메일무단수집거부 </template>
      <template #content>
        <article>
          <div class="terms">
            <strong
              >본 홈페이지에 게재된 이메일 주소가 전자우편 수집 프로그램이나 그
              밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를
              위반시 정보통신망이용촉진및정보보호등에관한법률 제50조의 2 규정에
              의하여 1천만원이하의 벌금형에 처함을 유념하시기 바랍니다.</strong
            >
            <p>
              <em>①</em> 누구든지 전자우편 주소의 수집을 거부하는 의사가 명시된
              인터넷 홈페이지에서 자동으 로 전자우편 주소를 수집하는 프로그램 그
              밖의 기술적 장치를 이용하여 전자우편 주소를 수 집하여서는
              아니된다.
            </p>
            <p>
              <em>②</em> 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를
              판매 유통하여서는 아니된다.
            </p>
            <p>
              <em>③</em> 누구든지 제1항 및 제2항의 규정에 의하여 수집, 판매 및
              유통이 금지된 전장편주소임을 알고 이를 정보전송에 이용하여서는
              아니된다.
            </p>
          </div>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="closeModal">
          <span class="hidden">닫기</span>
        </button>
      </template>
    </email-modal>
  </footer>
</template>

<script>
import EmailModal from '@/components/ContentsModal.vue';

export default {
  data() {
    return {
      showEmailModal: false,
    };
  },

  components: {
    EmailModal,
  },

  methods: {
    openWebsite(url) {
      window.open(url);
    },

    openEmailModal() {
      this.showEmailModal = true;
    },

    closeModal() {
      this.showEmailModal = false;
    },

    goExternalSite() {
      const agent = navigator.userAgent.toUpperCase();
      let Safari = false;

      if (agent.indexOf('SAFARI') >= 0) {
        if (agent.indexOf('CHROME') >= 0) {
          Safari = false;
        } else {
          Safari = true;
        }
      }

      if (/Mobi/i.test(window.navigator.userAgent) || Safari) {
        location.href = this.$refs.moveSite.value;
      } else {
        window.open(this.$refs.moveSite.value, '_blank');
      }
    },

    eventStem(e) {
      switch (e.keyCode) {
        case 37:
          e.preventDefault();
          break;
        case 38:
          e.preventDefault();
          break;
        case 39:
          e.preventDefault();
          break;
        case 40:
          e.preventDefault();
          break;
      }
    },
  },
};
</script>
